import confetti from "canvas-confetti";

/**
 * Fires the shared celebration confetti effect inside the container with the
 * given DOM id. A temporary absolutely-positioned canvas (id "effectCanvas")
 * is appended to the container, a single confetti burst is fired from near the
 * bottom of the viewport via canvas-confetti, and the canvas is removed again
 * after 3 seconds. The optional overrides exist only to preserve the small
 * visual differences between call sites (the FlyCut share dialog uses a
 * slightly taller canvas and a denser burst); when omitted, the defaults match
 * the onboarding step 4/step 7 effect.
 */
export function fireConfetti(
  containerId: string,
  options: {
    height?: string;
    bottom?: string;
    particleCount?: number;
    spread?: number;
    originY?: number;
  } = {}
): void {
  const { height = "90vh", bottom = "10vh", particleCount = 250, spread = 90, originY = 0.9 } = options;

  // add confetti effect
  const myCanvas = document.createElement("canvas");

  // Set Style Attributes on Element
  myCanvas.setAttribute(
    "style",
    `
        width: 100%;
        height: ${height};
        bottom: ${bottom};
        position: absolute;
        left: 0;
        `
  );
  myCanvas.setAttribute("id", "effectCanvas");

  document.getElementById(containerId).appendChild(myCanvas);

  const myConfetti = confetti.create(myCanvas, {
    resize: true,
    useWorker: true,
  });

  myConfetti({
    particleCount,
    spread,
    origin: { y: originY },
  });
  const effectCanvas = document.getElementById("effectCanvas");
  setTimeout(() => {
    document.getElementById(containerId)?.removeChild(effectCanvas);
  }, 3000);
}
